import Card from "./Card"
import Header from "./Header"
import Content from "./Content"

export default { Card, Header, Content }
